module.exports = __webpack_public_path__ + "media/images/category/feature/profile/profile-pan-010af845bb7635696f650cecc163b48b.jpg";